"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.factory = void 0;
const store_1 = require("@festival/tag/store");
const factory = () => {
    return {
        key: 'tagStore',
        dependencies: ['endpointStore'],
        create: (endpointStore) => new store_1.Store(endpointStore)
    };
};
exports.factory = factory;
